<template>
    <div v-if="templates && templates.length">
        <span v-if="title" class="agenda-question">{{ title }}</span>
        <l-input-typeahead
            :show-picture="false"
            :label="''"
            :placeholder="$t(`meetings.selectTemplate`)"
            :data="templates"
            :on-select="onSelect"
            :on-input-change="() => {}"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import LInputTypeahead from "@/components/LInputTypeahead";

export default {
    components: {
        LInputTypeahead,
    },
    created() {
        this.$store.dispatch("meetings/templates/getList").then(() => {
            this.onLoad(this.meetingTempaltes);
        });
    },
    computed: {
        ...mapGetters({
            meetingTempaltes: "meetings/templates/list",
        }),
        templates() {
            return this.meetingTempaltes.map(meetingTemplate => ({
                ...meetingTemplate,
                name: meetingTemplate.title,
            }));
        },
    },
    props: {
        onSelect: {
            type: Function,
        },
        onLoad: {
            type: Function,
            default: () => {},
        },
        title: {
            type: String,
            default: "",
        },
    },
};
</script>
